import { render, staticRenderFns } from "./CommonRow.vue?vue&type=template&id=38cebb11"
import script from "./CommonRow.vue?vue&type=script&lang=js"
export * from "./CommonRow.vue?vue&type=script&lang=js"
import style0 from "./CommonRow.vue?vue&type=style&index=0&id=38cebb11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports